import React from 'react';
import './Educator.css';

const pillars = [
  {
    num: '01',
    title: 'Creating Curriculum',
    desc: 'BFA, MA and MFA programs in Costume Design — balancing historical depth with contemporary practice.',
  },
  {
    num: '02',
    title: 'Teaching Courses',
    desc: 'Costume design for Theatre, Opera, Dance, Film and TV — taught with a professional lens and rigorous craft.',
  },
  {
    num: '03',
    title: 'Mentoring Students',
    desc: 'Building real bridges between students and the professional industry — from classroom to production.',
  },
];

const Educator = () => {
  return (
    <div className="educator">
      <div className="section-inner">
        <div className="educator-top">
          <div className="educator-text">
            <div className="section-label">Educator</div>
            <h2 className="section-title">
              Teaching the <em>Art</em><br />of Costume
            </h2>
            <p>
              As Costume Design Coordinator at the Academy of Art University's School of Fashion,
              Alina's pedagogy bridges professional practice and academic inquiry. Her courses span
              BFA, MA, and MFA levels across Theater, Opera, Dance, Film, and Television.
            </p>
            <p>
              Her approach emphasizes costume construction with a focus on historical garments as well
              as modern deconstructive and sustainable practices — fusing rigorous technique with
              artistic vision.
            </p>
            <p>
              At the heart of her teaching is a belief that design students deserve real professional
              opportunities while pursuing their education. She has built a curriculum that connects
              emerging designers directly with the industry.
            </p>
          </div>
          <a
            href="https://youtu.be/pFUnY97Ohw0"
            target="_blank"
            rel="noopener noreferrer"
            className="yt-link educator-video-wrap"
          >
            <img src="/aca_logo.gif" alt="Academy of Art University" />
            <div className="yt-play">
              <div className="yt-play-btn" />
              <span className="yt-play-label">Watch on YouTube</span>
            </div>
          </a>
        </div>

        <div className="educator-pillars">
          {pillars.map((pillar) => (
            <div key={pillar.num} className="pillar">
              <div className="pillar-num">{pillar.num}</div>
              <div className="pillar-title">{pillar.title}</div>
              <div className="pillar-desc">{pillar.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Educator;